import LanguageTab from "./languageTab.component";

export default LanguageTab;
